var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 5840,
    viewBox: "0 0 1440 5840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_962_1284)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5840,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 275.263,
    transform: "matrix(-1 0 0.000210592 -1 1440 275.264)",
    fill: "url(#paint0_linear_962_1284)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 72.1664,
    transform: "matrix(-1 0 0.000210592 -1 1440.04 72.167)",
    fill: "url(#paint1_linear_962_1284)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 275.263,
    transform: "matrix(-1 0 0.000210592 -1 1441 274.764)",
    fill: "url(#paint2_linear_962_1284)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 72.1664,
    transform: "matrix(-1 0 0.000210592 -1 1440.04 71.667)",
    fill: "url(#paint3_linear_962_1284)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1439.89,
    height: 493,
    transform: "matrix(-1 0 0.000217093 1 1439.89 1905)",
    fill: "url(#paint4_linear_962_1284)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1439.89,
    height: 129.251,
    transform: "matrix(-1 0 0.000217093 1 1439.97 2268.75)",
    fill: "url(#paint5_linear_962_1284)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.32 3942.52C229.587 3942.03 391.067 3822.95 459.361 3770.82C496.797 3742.3 553.627 3671.8 588.193 3596.56C622.638 3521.32 673.1 3450.2 766.032 3450.08C858.964 3450.08 919.543 3671.16 985.803 3685.05C1052.06 3699.06 1138.11 3585.13 1232.35 3596.56C1326.48 3608 1375.55 3679.2 1388.47 3711.04C1401.38 3743.01 1431.42 3790.69 1439.19 3852.28C1448.88 3929.49 1368.39 3942.52 1368.39 3942.52C1368.39 3942.52 310.559 3942.4 310.32 3942.52Z",
    fill: "url(#paint6_linear_962_1284)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.182 3940.81C229.44 3940.32 390.939 3821.15 459.241 3768.98C496.681 3740.44 553.519 3669.89 588.088 3594.59C622.538 3519.3 673.006 3448.12 765.949 3448C858.892 3448 919.479 3669.24 985.747 3683.15C1052.02 3697.17 1138.07 3583.15 1232.33 3594.59C1326.47 3606.04 1375.54 3677.29 1388.46 3709.16C1401.38 3741.15 1431.41 3788.86 1439.19 3850.51C1448.88 3927.77 1368.38 3940.81 1368.38 3940.81C1368.38 3940.81 310.421 3940.69 310.182 3940.81Z",
    fill: "url(#paint7_linear_962_1284)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.603 3707.4C295.383 3737.4 212 3850.9 212 3850.9H1375.93V3596.9C1375.93 3596.9 1342.35 3716.3 1280.77 3750.4C1158.27 3818.23 1148.45 3513.63 1009.04 3514.4C902.698 3514.98 873.177 3609.4 773.608 3657.9C674.039 3706.4 614.2 3731.9 493.54 3726.4C428.796 3718.9 375.823 3677.4 335.603 3707.4Z",
    fill: "url(#paint8_linear_962_1284)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 1439.53,
    height: 252.499,
    transform: "matrix(1 0 -0.000210592 1 0 4565.75)",
    fill: "url(#paint9_linear_962_1284)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1439.53,
    height: 177.582,
    transform: "matrix(1 0 -0.000210592 1 -0.0151367 4640.67)",
    fill: "url(#paint10_linear_962_1284)",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_962_1284",
    x1: 918.514,
    y1: 275.263,
    x2: 916.692,
    y2: -0.0356089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1477F8",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_962_1284",
    x1: 918.514,
    y1: 72.1664,
    x2: 918.389,
    y2: -0.0122804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1477F8",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_962_1284",
    x1: 918.514,
    y1: 275.263,
    x2: 916.692,
    y2: -0.0356089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1477F8",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_962_1284",
    x1: 918.514,
    y1: 72.1664,
    x2: 918.389,
    y2: -0.0122804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1477F8",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_962_1284",
    x1: 918.446,
    y1: 493,
    x2: 912.601,
    y2: -0.0160827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1477F8",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_962_1284",
    x1: 918.446,
    y1: 129.251,
    x2: 918.044,
    y2: -0.0211347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1477F8",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_962_1284",
    x1: 959.027,
    y1: 3462.56,
    x2: 959.027,
    y2: 3942.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_962_1284",
    x1: 958.967,
    y1: 3460.49,
    x2: 958.967,
    y2: 3941.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_962_1284",
    x1: 889.877,
    y1: 3522.92,
    x2: 889.877,
    y2: 3851.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_962_1284",
    x1: 725.033,
    y1: 240.707,
    x2: 734.008,
    y2: -184.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_962_1284",
    x1: 778.111,
    y1: 177.582,
    x2: 787.781,
    y2: -111.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1477F8",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_962_1284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5840,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.574515d713f0f4aed568f7efddee6f5f.svg";
export { ForwardRef as ReactComponent };